import { makeStyles, useTheme } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
	unassigned: {
		// maxWidth: 275,
		// minWidth: 275,
		height: 92,
		backgroundColor: ({ backgroundColor }) => backgroundColor,
		borderRadius: 6,
		boxShadow: '0px 2px 10px rgba(26, 26, 53, 0.1)',
		display: 'flex',
		// flexDirection: 'row',
		// justifyContent: 'space-between',
		alignItems: 'center',
		padding: 20,
		cursor: ({ cursor }) => cursor,
		'& i.fa-chevron-right': {
			color: 'rgba(255, 255, 255, 0.6)',
			fontSize: 18
		},
		'& i.fa-exclamation-circle': {
			color: '#DB4A42',
			fontSize: 25,
			position: 'absolute',
			top: '22px',
			right: '3%'
		}
	},
	textBox: {
		width: ({ textBoxWidth }) => textBoxWidth,
		marginRight: ({ textBoxMargin }) => textBoxMargin,
		justifyContent: 'center',
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		'& h5, p': {
			fontFamily: 'Nunito',
			fontStyle: 'normal',
			fontWeight: '800'
		},
		'& h5': {
			color: ({ labelColor }) => labelColor,
			fontSize: '12px',
			lineHeight: '19px',
			margin: 0,
			textTransform: 'uppercase',
			letterSpacing: '1.25px'
		},
		'& p': {
			color: ({ textColor }) => textColor,
			fontSize: '34px',
			lineHeight: '49px',
			margin: 0
		}
	}
}))

export const StatBox = ({ label, number, onClick = null, dark = false, showArrow = false, showAlert = false }) => {
	const theme = useTheme()
	const classes = useStyles({
		cursor: showArrow ? 'pointer' : undefined,
		textBoxMargin: showArrow ? 27 : 0,
		textBoxWidth: showArrow ? '90%' : '100%',
		backgroundColor: dark ? '#6B4AD6' : '#FFFFFF',
		labelColor: dark ? '#FFF' : '#5F38BE',
		textColor: dark ? '#FFF' : '#1A1A35'
	})

	return (
		<div
			className={classes.unassigned}
			onClick={() => {
				if (onClick && showArrow) onClick()
			}}>
			<div className={classes.textBox}>
				<h5>{label}</h5>
				<p>{number}</p>
			</div>
			{onClick && showArrow && <i className="fa fa-chevron-right" />}
			{showAlert && <i className="fas fa-exclamation-circle" />}
		</div>
	)
}
